import React from 'react';

import { Paragraph, Text } from '@zillow/constellation';

import type { Section } from '../../../models/index';
import YesAndNo from '../../Widgets/YesAndNo';
import { ROAM_TOWING } from '../../../constants';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

export default function RoamTowing({ section, setSectionValues }: Props): JSX.Element {
  function onNoRoamTowing(): void {
    setSectionValues({
      [ROAM_TOWING.FIELD_NAME.IS_ENABLED]: false,
    });
  }

  function onYesRoamTowing(): void {
    setSectionValues({
      [ROAM_TOWING.FIELD_NAME.IS_ENABLED]: true,
    });
  }

  return (
    <>
      <Text fontType="h6">Do you use roam towing services on your property?</Text>
      <Paragraph marginBottom="sm">Roam towing services seek and tow vehicles parked on private property.</Paragraph>
      <YesAndNo
        yesHandler={onYesRoamTowing}
        noHandler={onNoRoamTowing}
        yesActive={section.getFieldValue(ROAM_TOWING.FIELD_NAME.IS_ENABLED)}
      />
    </>
  );
}
